const types = {
    INFO_CATEGORIES_REQUEST: 'info/INFO_CATEGORIES_REQUEST',
    INFO_CATEGORIES_REQUEST_COMPLETED: 'info/INFO_CATEGORIES_REQUEST_COMPLETED',
    INFO_CATEGORY_DETAIL_REQUEST: 'info/INFO_CATEGORY_DETAIL_REQUEST',
    INFO_CATEGORY_DETAIL_REQUEST_COMPLETED: 'info/INFO_CATEGORY_DETAIL_REQUEST_COMPLETED',
    INFO_REQUEST: 'info/INFO_REQUEST',
    INFO_REQUEST_COMPLETED: 'info/INFO_REQUEST_COMPLETED',
    INFO_DETAIL_REQUEST: 'info/INFO_DETAIL_REQUEST',
    INFO_DETAIL_REQUEST_COMPLETED: 'info/INFO_DETAIL_REQUEST_COMPLETED',
};

const createTypes = {
    ADD_INFO_CATEGORY_REQUEST: 'info/ADD_INFO_CATEGORY_REQUEST',
    ADD_INFO_REQUEST: 'info/ADD_INFO_REQUEST',
};

const updateTypes = {
    UPDATE_INFO_CATEGORY_REQUEST: 'info/UPDATE_INFO_CATEGORY_REQUEST',
    UPDATE_INFO_CATEGORY_ORDER: 'info/UPDATE_INFO_CATEGORY_ORDER',
    UPDATE_INFO_REQUEST: 'info/UPDATE_INFO_REQUEST',
    UPDATE_INFO_ORDER: 'info/UPDATE_INFO_ORDER',
};

const deleteTypes = {
    DELETE_INFO_CATEGORY_REQUEST: 'info/DELETE_INFO_CATEGORY_REQUEST',
    DELETE_INFO_CATEGORY_REQUEST_COMPLETED: 'info/DELETE_INFO_CATEGORY_REQUEST_COMPLETED',
    DELETE_INFO_REQUEST: 'info/DELETE_INFO_REQUEST',
    DELETE_INFO_REQUEST_COMPLETED: 'info/DELETE_INFO_REQUEST_COMPLETED',
};

export default {
    ...types,
    ...createTypes,
    ...updateTypes,
    ...deleteTypes,
};
